import { DateTime } from "luxon";
import { mapServiceKey } from "./services-utils";
// SQL Outputs
const sqlToObject = (columns, row) =>
  columns.reduce((acc, key, index) => {
    const fixedKey = key === "date" ? "datetime" : key;
    let value = row[index];
    if (fixedKey === "datetime") {
      value = DateTime.fromISO(value.replace(" ", "T"), { zone: "UTC" }).toISO();
    }
    if (key === "Datetime") {
      value = DateTime.fromSeconds(value, { zone: "UTC" }).toISO();
    }
    return { ...acc, [fixedKey]: value };
  }, {});

const arrayIndexFromDatetime = (datetime, timeInterval) => {
  const currentDate = DateTime.fromISO(datetime, { zone: "UTC" });
  const yearStart = DateTime.fromISO(datetime, { zone: "UTC" }).startOf("year");
  const { minutes } = currentDate.diff(yearStart, "minutes").toObject();
  const index = Math.floor(minutes / timeInterval);
  return index;
};

const parseSQLYearly = (projectObj, dbSql) => {
  const projectCopy = projectObj;
  const projectId = projectObj.id;
  const parsed = {};
  ["markets", "storages", "demands", "generators"].forEach((resource) => {
    const response = dbSql.exec(
      `SELECT * FROM 'yearly_${resource}' where projectID = ${projectId}`
    );
    if (response[0]) {
      const objectKeys = response[0].columns;
      response[0].values.forEach((row) => {
        const rowObject = sqlToObject(objectKeys, row);
        const { year, name: resourceName } = rowObject;
        if (!parsed[year]) {
          parsed[year] = {
            markets: {},
            storages: {},
            demands: {},
            generators: {},
          };
        }
        if (!parsed[year][resource][resourceName]) {
          parsed[year][resource][resourceName] = rowObject;
        }
      });
    }
  });

  // Get yearly services
  const services = dbSql.exec(`SELECT * FROM 'yearly_services'`);
  if (services[0]) {
    const objectKeys = services[0].columns;
    services[0].values.forEach((row) => {
      const rowObject = sqlToObject(objectKeys, row);
      const { servicableID, year, resourceName, serviceName } = rowObject;
      const servicable = dbSql.exec(
        `SELECT * FROM 'servicables' where id=${servicableID} AND projectID=${projectId}`
      );
      if (servicable[0]) {
        const servicableObj = sqlToObject(servicable[0].columns, servicable[0].values[0]);
        const { type } = servicableObj;
        parsed[year][type.replace("yearly_", "")][resourceName][serviceName] = rowObject;
      }
    });
  }

  projectCopy.yearlyResults = parsed;
  return projectCopy;
};

const parseSQLResources = (resResponse) => {
  const parsed = {};
  if (resResponse[0]) {
    const objectKeys = resResponse[0].columns;
    resResponse[0].values.forEach((row) => {
      const rowObject = sqlToObject(objectKeys, row);
      const { datetime, name: resourceName } = rowObject;
      const { year } = DateTime.fromISO(datetime, { zone: "UTC" });
      if (!parsed[resourceName]) {
        parsed[resourceName] = {
          [year]: [rowObject],
        };
      } else if (!parsed[resourceName][year]) {
        parsed[resourceName][year] = [rowObject];
      } else {
        parsed[resourceName][year].push(rowObject);
      }
    });
  }
  return parsed;
};

const parseSQLTimeSeriesResources = (projectObj, dbSql) => {
  const projectCopy = projectObj;
  ["markets", "storages", "thermal_generators", "renewable_generators", "demands"].forEach(
    (resource) => {
      const resResponse = dbSql.exec(
        `SELECT * FROM '${resource}' where projectID = ${projectObj.id}`
      );
      const parsedResources = parseSQLResources(resResponse);

      let resourceKey;
      // if (["thermal_generators", "renewable_generators"].includes(resource)) {
      //   resourceKey = { thermal_generators: "thermalGens", renewable_generators: "renGens" }[
      //     resource
      //   ];
      // }
      projectCopy[resourceKey || resource] = parsedResources;
    }
  );
  return projectCopy;
};

const parseSQLTimeSeriesServices = (projectObj, dbSql, timeInterval) => {
  const projectCopy = projectObj;
  // Load servicables into id keyed object
  const servicables = {};
  const servicablesQuery = dbSql.exec(`SELECT * FROM 'servicables'`);
  if (servicablesQuery[0]) {
    const objectKeys = servicablesQuery[0].columns;
    servicablesQuery[0].values.forEach((row) => {
      const rowObject = sqlToObject(objectKeys, row);
      const { id } = rowObject;
      servicables[id] = rowObject;
    });
  }
  // Get yearly services
  const services = dbSql.exec(`SELECT * FROM 'services'`);
  if (services[0]) {
    const objectKeys = services[0].columns;
    services[0].values.forEach((row) => {
      // How to avoid using find for each record? Currently O(N*Nlog(N))
      const rowObject = sqlToObject(objectKeys, row);
      const { servicableID, serviceName, subServiceName, datetime } = rowObject;
      const { type, name } = servicables[servicableID];
      const { year } = DateTime.fromISO(datetime, { zone: "UTC" });
      rowObject.name = mapServiceKey(serviceName);

      // Let's assume that values come in order and all timestamps have values
      const valueIndex = arrayIndexFromDatetime(datetime, timeInterval);
      if (valueIndex >= 0) {
        if (serviceName === "R") {
          if (!projectCopy[type][name][year][valueIndex].R) {
            projectCopy[type][name][year][valueIndex].R = {};
          }
          projectCopy[type][name][year][valueIndex].R[subServiceName] = rowObject;
        } else {
          projectCopy[type][name][year][valueIndex][serviceName] = rowObject;
        }
      }
    });
  }
  return projectCopy;
};

export { sqlToObject, parseSQLYearly, parseSQLTimeSeriesResources, parseSQLTimeSeriesServices };
